// extracted by mini-css-extract-plugin
export var container = "_36-0";
export var icon = "_36-1";